/**
 * The working indicator: a 3x3 pixel grid with a chevron wavefront driving
 * right. A spinner says "wait"; this says "something is being worked on", which
 * is what a session row means when the agent is mid-run.
 *
 * The cycle (650ms) is deliberately shorter than the sweep across the grid, so
 * two fronts are always in flight and the motion never reads as a stall. Under
 * `prefers-reduced-motion` the grid freezes to its dim state — still a visible
 * marker on the row, just not a moving one (the CSS does that; see
 * `pixel-on` in globals.css).
 */

/** Per-cell delay: column plus distance from the middle row — the chevron. */
const CHEVRON_DELAYS = Array.from({ length: 9 }, (_, i) => {
  const row = Math.floor(i / 3)
  const col = i % 3
  return (col + Math.abs(row - 1)) * 90
})

export function ActivityGrid({ title = 'Working' }: { title?: string }) {
  return (
    <span
      title={title}
      aria-label={title}
      role="img"
      className="grid shrink-0 grid-cols-[repeat(3,3px)] gap-[1.5px]"
    >
      {CHEVRON_DELAYS.map((delay, cell) => (
        <span
          // biome-ignore lint/suspicious/noArrayIndexKey: fixed 3x3 grid, cells never reorder
          key={cell}
          className="size-[3px] rounded-[1px] bg-blue-400 opacity-20"
          style={{
            animation: `pixel-on 650ms ease-in-out ${delay}ms infinite`,
          }}
        />
      ))}
    </span>
  )
}
